import React from 'react';
import ConsolidatedMeasurements from '../../../../components/IndividualCharts/ConsolidatedMeasurements/ConsolidatedMeasurements';
import { useDynamicViewState } from '../../context/dynamic-view-context';
import { useFetchEventsMeasurements } from '../../hooks/useFetchEventsMeasurements';
import { format } from 'date-fns';
import { api_auth } from '../../../../common/globals/constants';
import { Alert } from '@mui/material';
import { AtCircularProgress } from '../../../../components/AtCircularProgress';

const URL_PARAMS = ({ objetivoId, periodo }) => {
  let fechaInicio = '';
  let fechaTermino = '';

  if (periodo.period === 'c') {
    fechaInicio = format(new Date(periodo.statePeriod.startDate), 'yyyy-MM-dd');
    fechaTermino = format(new Date(periodo.statePeriod.endDate), 'yyyy-MM-dd');
  }

  const token = sessionStorage.getItem('key');

  const URL = new URLSearchParams();
  URL.append('objetivoId', objetivoId);
  URL.append('token', token);
  URL.append('key', api_auth);
  URL.append('horarioId', '0');

  if (periodo.period === 'c') {
    URL.append('fechaInicio', fechaInicio);
    URL.append('fechaTermino', fechaTermino);
    URL.append('nodoId', '0');
  } else {
    URL.append('t', periodo.period);
  }

  return URL;
};

const ConsolidatedMeasurementsChart = ({ objetivoId }) => {
  const { filterPeriod, refreshTime } = useDynamicViewState();

  const {
    data: dataDisponibility,
    isLoading: isLoadingDisponibility,
    error: errorDisponibility,
    isFetching: isFetchingDisponibility,
  } = useFetchEventsMeasurements({
    urlParams: URL_PARAMS({ objetivoId, periodo: filterPeriod }),
    fetchApi:
      filterPeriod.period === 'c'
        ? 'getResumenDisponibilidadParcialObjetivoCustom'
        : 'getResumenDisponibilidadParcialObjetivo',
    refreshTime,
  });
  const {
    data: dataPerformance,
    isLoading: isLoadingPerformance,
    error: errorPerformance,
    isFetching: isFetchingPerformance,
  } = useFetchEventsMeasurements({
    urlParams: URL_PARAMS({ objetivoId, periodo: filterPeriod }),
    fetchApi:
      filterPeriod.period === 'c'
        ? 'getResumenRendimientoParcialObjetivoCustom'
        : 'getResumenRendimientoParcialObjetivo',
    refreshTime,
  });
  const {
    data: dataMeasurements,
    isLoading: isLoadingMeasurements,
    error: errorMeasurements,
    isFetching: isFetchingMeasurements,
  } = useFetchEventsMeasurements({
    urlParams: URL_PARAMS({ objetivoId, periodo: filterPeriod }),
    fetchApi:
      filterPeriod.period === 'c'
        ? 'getTotalMedicionesParcialCustom'
        : 'getTotalMedicionesParcial',
    refreshTime,
  });

  const isLoading =
    isLoadingDisponibility || isLoadingPerformance || isLoadingMeasurements;
  const isFetching =
    isFetchingDisponibility || isFetchingPerformance || isFetchingMeasurements;
  const error = errorDisponibility || errorPerformance || errorMeasurements;

  if (isLoading || isFetching) return <AtCircularProgress />;
  if (error) return <Alert severity="error">Error al cargar los datos.</Alert>;

  return (
    <ConsolidatedMeasurements
      dataDisponibility={dataDisponibility}
      dataResponse={dataPerformance}
      dataMeasurements={dataMeasurements}
    />
  );
};

export default React.memo(ConsolidatedMeasurementsChart);
